export const mandatory = {
  item: [
    {
      question:
        "What are the essential requirements/documents required to apply for this scholarship?",
      answers: [
        "Mobile Number linked to Aadhaar card of the applicant.",
        "Email Address of the applicant.",
        "Income Certificate or intimation u/s 143(1) document of earning members.",
        "Birth Certificate.",
        "Admission letter of enrollment into first year of two-year full-time MBA program 2024-26 batch/ four-year full-time Engineering program 2024-28 batch from the list of eligible colleges and campuses.",
        "Confirmation letter of Fees paid to the college/ Fee Payment receipt.",
        "Birth Certificate.",
        "Address proof if the Current address is different from the address mentioned in the Aadhar Card.",
      ],
    },
  ],
};

export const programEligibility = {
  item: [
    {
      question:
        "I do not have Aadhar Card, can I still apply for the scholarship?",
      answers: [
        "No, if you do not have an Aadhar card, you are not eligible to apply for this scholarship.",
      ],
    },
    {
      question:
        "Is it mandatory to have a mobile number linked to Aadhar card, to apply for the scholarship?",
      answers: [
        [
          "Yes, it is mandatory to have the applicant's mobile number linked to their Aadhar Card in order to apply for the scholarship.",
        ],
      ],
    },
    {
      question: "Is this scholarship only open for Indian Nationals?",
      answers: [
        "Yes, this scholarship is only open for Indian nationals studying in campuses within the territory of India.",
      ],
    },
    {
      question:
        "Can MBA students of previous batch/batches apply for this scholarship?",
      answers: [
        "No, only students who are enrolled in the first year of the full time MBA / PGDM/ MMS program in the academic year 2024-2026 are eligible to apply for this scholarship.",
      ],
    },
    {
      question:
        "Can Engineering students of previous batch/batches apply for this scholarship?",
      answers: [
        "No, only students who are enrolled in the first year of their full-time B.E. / B. Tech program in the academic year 2024-28 (Batch of 2024-28) are eligible to apply for this scholarship.",
      ],
    },
    {
      question:
        "I am pursuing my MBA through distance education/ Part-time MBA. Am I eligible for this scholarship?",
      answers: [
        "No, only students pursuing MBA full time are eligible for the scholarship.",
      ],
    },
    {
      question:
        "I am in my second year of MBA, am I eligible for this scholarship?",
      answers: [
        "No, only students enrolled in the first year of their full time MBA /PGDM/ MMS program in the academic year 2024-26(Batch of 2024-26) are eligible to apply for this scholarship.",
      ],
    },
    {
      question:
        "I am in my second year of Engineering, am I eligible for this scholarship?",
      answers: [
        "No, only students enrolled in the first year of their full-time B.E. / B. Tech program in the academic year 2024-28 (Batch of 2024-28) are eligible to apply for this scholarship.",
      ],
    },
    {
      question:
        "I am enrolled in the batch of 2023-25 MBA Scholarship but did not clear my first year, Am I eligible to apply?",
      answers: [
        "If you have been an IDFC FIRST bank MBA scholar in previous year(s), have not cleared your first year of the program and are re-appearing for your first year examination, then you are not eligible to re-apply for the scholarship. however, if you are not an existing scholar of the IDFC FIRST Bank scholarship, then you may apply for the scholarship irrespective of the status of your results of the first year.",
      ],
    },
    {
      question:
        "I am enrolled in batch of 2023-27 Engineering Scholarship, but did not clear my first year, Am I eligible to apply?",
      answers: [
        "If you have been an IDFC FIRST Bank Engineering scholar in previous year(s) and have not cleared your first year and are reappearing first year, then you are not eligible to re-apply for the scholarship. However, if you are not an existing scholar of the IDFC FIRST Bank Scholarship, then you may apply for the scholarship irrespective of the status of your results of the first year.",
      ],
    },
    {
      question:
        "I had applied for this scholarship last year, but I did not receive it. can I re-apply for the scholarship again this year?",
      answers: [
        "If you are in the first year of your full time MBA program, you may apply for the scholarship previous years applications have no effect on next year's eligibility.",
      ],
    },
    {
      question: "For how many years will I receive the scholarship?",
      answers: [
        "Selected MBA Scholars shall receive the scholarship for two consecutive years of their full time MBA program given that the candidate clears his/ her first year in academic year 2024-25 and is promoted to the second year in academic year 2025-26.",
        "Selected Engineering scholars shall receive the scholarship for four consecutive years for their full time Engineering program given that the candidate clears his / her first year in academic year 2024-25 and is promoted to the second year in academic year 2025-26, ",
      ],
    },
    {
      question: "Are there any application fees to apply for the scholarship?",
      answers: [
        "No, there is no application fee to apply for the IDFC FIRST Bank MBA scholarship or IDFC FIRST Bank Engineering scholarship.",
      ],
    },
    {
      question:
        "Is it mandatory to pass the first year to be eligible for scholarship amount of next year?",
      answers: [
        "Yes, it is mandatory for all the scholars to pass the first year and be promoted to second year in the next consecutive year to be eligible for the scholarship in the second year.",
      ],
    },
  ],
};

export const collegeEligibility = {
  item: [
    {
      question:
        "I cannot find my college in the list of colleges eligible scholarship program, what are my options?",
      answers: [
        "Please note, this is the full and final list of eligible colleges for the current batch of scholarship and is not subject to any further change. If your college is not mentioned in the list of eligible colleges then, unfortunately you would not be eligible to apply further scholarship at this time. you may suggest colleges that you would like the bank to explore for the coming years. though this does not guarantee an addition of the college in the coming years.",
      ],
    },
    {
      question:
        "I can find the name of my college in the list, but the name is of a different campus from the campus I attend, am I still eligible?",
      answers: [
        "You are eligible to apply for the scholarship if your college name is mentioned in the list, irrespective of the campus location mentioned. although the campus needs to be basic within the boundaries of India. Students based in campuses outside of India are not eligible to apply.",
      ],
    },
  ],
};

export const familyIncome = {
  item: [
    {
      question: "How do you define `Family` while calculating income?",
      answers: [
        "Income from family members including parents or guardians, spouse, unmarried daughters and unmarried brothers/ sisters of the individual applying for the scholarship is taken into consideration while calculating income.",
        "Income from widowed daughter/ sister is excluded when calculating what is family income.",
      ],
    },
    {
      question: "Which documents are acceptable as proof of family income?",
      answers: [
        "Income Certificate & intimation u/s 143(1) document of last financial year, no income certificate the are acceptable proofs for the calculation of family income.",
      ],
    },
    {
      question:
        "I do not have any earning member in the family, what document do I upload?",
      answers: [
        "A valid, no-income certificate issued by an authority under the State Government would be needed in this case. Applicants are requested to check the validity of the certificate before submitting their applications.",
        "Please refer to the next FAQ for more information",
      ],
    },
    {
      question: "What is an Income Certificate and its validity?",
      answers: [
        "An income certificate is a document issued by an Authority under the state government certifying the annual  income of a person or a family from all sources, including salary, daily wages,pension,business, producers from property, rent, and remittances from expatriate members.",
        "The authority that issues the certificate varies from state to state. In most cases, it is the Village Tahsildars that issue this certificate, but many states and union territories also have District Magistrate, Deputy Commissioner, Collector, Revenue Circle Officers, Sub Divisional Magistrates or other District Authorities appointed for this purpose. You are requested to check on the issuing authority of your state for this requirement.",
        "The income certificate is valid for the financial year mentioned in the certificate and varies from state to state. Applicants are requested to check for validity of the certificate before applying.",
        "Students applying for batch starting in 2024 must ensure that their certificates are valid for FY 2024-25.",
      ],
    },
    {
      question:
        "Is the Economically Weaker Section (EWS) Certificate valid proof of Income?",
      answers: [
        "No, The EWS certificate is an income and asset certificate issued to the economically weaker category and is not acceptable as income proof because it does not establish the exact income of the applicant.",
      ],
    },
    {
      question:
        "Can I submit only the agricultural income certificate as proof of income?",
      answers: [
        "No, an agricultural income certificate contains only details of income obtained from involvement in all agricultural activities, whereas an income certificate includes details of annual income for all sources.",
      ],
    },
  ],
};

export const collegeRelated = {
  item: [
    {
      question:
        "I cannot find my college in the list of colleges eligible scholarship program, what do I do?",
      answers: [
        "Please note, this is the full and final list of eligible colleges for the current batch of scholarship and is not subject to any further change, If your college is not mentioned in the list of eligible colleges then, unfortunately you would not be eligible to apply for the scholarship at this time. you may suggest colleges that you would like the bank to explore for the coming years. though this does not guarantee an addition to the college in the coming years.",
      ],
    },
    {
      question:
        "I can find the name of my college in the list but a different campus, am I still eligible?",
      answers: [
        "You are eligible to apply for the scholarship if your college name is mentioned in the list, irrespective of the campus location mentioned. although the campus needs to be basic within the boundaries of India. Students based in campuses outside of India are not eligible to apply.",
      ],
    },
  ],
};

export const docsRelated = {
  item: [
    {
      question: "",
      answers: [
        "All candidates would be required to update the name of the earning member as mentioned in the documents submitted.",
      ],
    },
  ],
};

export const technicalRelated = {
  item: [
    {
      question:
        "I have a query about the scholarship program, who do I need to get in touch with?",
      answers: [
        "Registered students can go to `Help` tab after Sign-in and click on 'Raise a Query' to submit a form.",
        <div>
          MBA students not yet registered can email{" "}
          <span style={{ color: "#9b1e26" }}>
            mbascholarship@idfcfirstbank.com
          </span>{" "}
          with the query.
        </div>,
        <div>
        Engineering students not yet registered can email{" "}
        <span style={{ color: "#9b1e26" }}>
          engscholarship@idfcfirstbank.com
        </span>{" "}
        with the query.
      </div>,
        "The CSR team will be in touch with you within 3 working days.",
      ],
    },
    {
      question: "I am facing a technical issue while logging in, what do I do?",
      answers: [
        "Registered candidate can go to `Help` tab after Sign-in and click on 'Raise a Query' to submit a form.",
        <div>
          Students not yet registered can email{" "}
          <span style={{ color: "#9b1e26" }}>
            mbascholarship@idfcfirstbank.com
          </span>{" "}
          with the query.
        </div>,
        <div>
        Engineering Students not yet registered can email{" "}
        <span style={{ color: "#9b1e26" }}>
          engscholarship@idfcfirstbank.com
        </span>{" "}
        with the query.
      </div>,
        "The CSR team will be in touch with you within 3 working days.",
      ],
    },
    {
      question:
        "What actions to be performed in case we face issues while registering and submitting application in Portal?",
      answers: [
        <div>
          <span>Internal server error -</span> Click on Resend OTP to Generate a
          fresh OTP and try again.
        </div>,
        <div>
          <span>No Password in the system -</span> No Password in the system	Click on Resend OTP to Generate a fresh OTP and try again.
        </div>,
        <div>
          <span>Incorrect OTP	 -</span> Click on Resend OTP to Generate a fresh OTP and try again.
        </div>,
        <div>
          <span>Something went wrong -</span> Please try after some time.
        </div>,
        <div>
        <span>Application Hanging or unable to upload documents -</span> Clear browser cache, cookies and retry login.
      </div>,
      ],
    },
    {
      question: "What is the recommended browser to fill application?",
      answers: [
        "Google Chrome is recommended internet browser to use for uninterrupted experience of the Student Portal.",
      ],
    },
  ],
};

export const dropoutRelated = (props) => {
  let currentUrl = window.location.href.replace(/^(https?:\/\/)?(www\.)?/i, "");
  let urlList = currentUrl.split("/");
  let item = [
    {
      question: "",
      answers: [
        {
          title: "Application Stage Drop-out:",
          contents: [
            "A candidate whose application is under verification, can opt to drop out at any time by raising a request through the portal, to notify the CSR Team.",
          ],
        },
        {
          title: "Drop-out of ‘Awarded’ Candidates:",
          contents: [
            "If a candidate, who has already been awarded the scholarship, wishes to drop out of the program midway, for any reason whatsoever, he/she must notify the CSR Team and obtain their approval.",
            "The candidate can raise a drop-out request through the portal. The request will be reviewed by the CSR Team, who will share the necessary approval.",
          ],
        },
        {
          title: "Refund of the Scholarship Amount:",
          contents: [
            "If the scholarship has already been disbursed to the candidate, the candidate and the SPOC of his/her college will receive instructions on how to refund the amount to the IDFC FIRST Bank account.",
            "The candidate’s drop-out request will be approved only after the college SPOC completes the refund, and the CSR Team confirms receipt of the refund.",
            <div className="drop-click">
              Raise Dropout by <span>clicking here</span>
            </div>,
          ],
        },
      ],
    },
  ];
  // if (urlList[2] === "help") {
  //   item[0].answers[2] = [item[0]?.answers[2].title,
  //     [...item[0]?.answers[2].contents],

  //     <div>
  //       Raise Dropout by <span>clicking here</span>
  //     </div>,
  //   ];
  // }
  return item;
};

export const addressRelated = {
  item: [
    {
      answers: [
        "The address mentioned as per the Aadhar records would be automatically considered as the Permanent address in the application form.",
        "If the current address is not same as a permanent address, there would be an option to enter the current address separately and upload a proof of the current address.",
      ],
    },
  ],
};
